// extracted by mini-css-extract-plugin
module.exports = {"customButton":"BlueButton_customButton__29xmp"};